import React from "react";
import { IconProps } from "./types";

export default function BrahmaLogoWithNameIcon({
  width = 24,
  height = 24,
  className = "",
  color = "#020202",
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 165 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17017 15.3146C0.526313 19.419 -0.400434 23.0071 1.12 24.5276C3.42603 26.8338 10.4882 23.5102 16.8939 17.1043C17.5275 16.4707 18.1309 15.8307 18.7017 15.1895C18.9591 15.6095 19.1836 16.0163 19.3726 16.4048C19.366 16.412 19.3595 16.4192 19.3529 16.4264C20.1113 18.0058 20.2753 19.2747 19.6688 19.8837L19.6736 19.8885C18.3637 21.1985 16.7764 22.062 15.1008 22.479C19.2043 25.1222 22.7915 26.0486 24.3118 24.5283C24.3295 24.5105 24.3469 24.4925 24.364 24.4742L24.4163 24.5265C26.1567 22.6732 24.4777 17.9446 20.5897 12.9132C24.4732 7.86762 26.1245 3.13742 24.3169 1.32973C22.7967 -0.190567 19.2094 0.735793 15.1059 3.379C16.7815 3.79602 18.3689 4.65953 19.6789 5.96955L19.6763 5.97221C20.4335 6.72947 19.9946 8.5117 18.7 10.6428C18.1411 10.0169 17.5512 9.39221 16.9327 8.77364C12.7767 4.61761 8.34487 1.75676 5.11017 0.884273C3.34268 0.403192 1.93094 0.514261 1.11486 1.33038C-0.405557 2.85086 0.521161 6.43895 3.16497 10.5433C3.58194 8.8674 4.44545 7.27986 5.75549 5.96977L5.75703 5.97131C5.7745 5.95391 5.79252 5.93714 5.81107 5.921L5.82939 5.93932C6.53614 5.31855 8.02553 5.61887 9.83682 6.6082C11.4192 7.47738 13.2449 8.87043 15.0074 10.6329C15.7709 11.3965 16.4651 12.1719 17.0774 12.9343C16.4673 13.6931 15.7762 14.4647 15.0164 15.2245C11.1748 19.0663 7.03252 21.1526 5.76448 19.8845L5.76073 19.8883C4.45065 18.5782 3.58713 16.9906 3.17017 15.3146Z"
        fill={color}
      />
      <path
        d="M53.6055 13.6965C53.3596 13.4604 53.065 13.2765 52.7218 13.1385C52.3787 13.0035 52.0022 12.9054 51.5861 12.8441C52.2815 12.6816 52.8312 12.3872 53.2259 11.9518C53.6237 11.5194 53.8242 10.8601 53.8242 9.97089C53.8242 8.78726 53.4142 7.91333 52.6034 7.34912C51.7926 6.78797 50.5901 6.50586 49.0019 6.50586H37.666V19.3234H49.5516C50.2834 19.3234 50.9484 19.2559 51.5406 19.121C52.1358 18.9861 52.6429 18.7714 53.065 18.4832C53.4871 18.1919 53.809 17.827 54.0367 17.3885C54.2614 16.95 54.3768 16.4287 54.3768 15.8216C54.3768 15.3401 54.31 14.9231 54.1764 14.5735C54.0428 14.2209 53.8515 13.9265 53.6085 13.6965H53.6055ZM40.5083 8.87924H49.0019C49.6244 8.87924 50.1133 8.98964 50.4686 9.21042C50.8239 9.43426 51.0001 9.81143 51.0001 10.3388C51.0001 10.8663 50.827 11.2526 50.4777 11.4489C50.1285 11.6482 49.6518 11.7463 49.0566 11.7463H40.5083V8.87618V8.87924ZM51.0395 16.6188C50.6934 16.8427 50.1984 16.95 49.5516 16.95H40.5083V13.9695H49.5516C50.25 13.9695 50.7541 14.0982 51.0729 14.3558C51.3887 14.6134 51.5497 14.9844 51.5497 15.4659C51.5497 16.0117 51.3796 16.3919 51.0395 16.6157V16.6188Z"
        fill={color}
      />
      <path
        d="M74.2133 13.4083C74.6324 12.7214 74.848 11.918 74.848 10.992V10.9736C74.848 10.3143 74.7447 9.71943 74.5443 9.17668C74.3439 8.63086 74.0251 8.16171 73.5817 7.76921C73.1414 7.37365 72.5705 7.06088 71.8751 6.84316C71.1767 6.61932 70.3416 6.50586 69.3638 6.50586H58.5957V9.08162V12.8962V19.3264H61.4411V15.3647H69.382L71.948 19.3264H75.1577L72.1484 14.9538C73.1049 14.6103 73.7912 14.0921 74.2164 13.4083H74.2133ZM71.9844 10.992C71.9844 11.6482 71.7718 12.1266 71.3497 12.4332C70.9276 12.7429 70.2626 12.8962 69.3577 12.8962H58.5957V9.08162H69.3577C70.2626 9.08162 70.9246 9.23801 71.3497 9.54158C71.7688 9.85129 71.9844 10.3296 71.9844 10.9705V10.9889V10.992Z"
        fill={color}
      />
      <path
        d="M131.998 13.8747L125.044 6.52148H122.293V19.339H125.172V10.5967L131.3 17.1159H132.694L138.819 10.5967V19.339H141.719V6.52148H138.946L131.998 13.8747Z"
        fill={color}
      />
      <path
        d="M115.018 11.6332H103.755V6.52148H100.84V19.339H103.755V14.2641H115.018V19.339H117.955V6.52148H115.018V11.6332Z"
        fill={color}
      />
      <path
        d="M89.1331 6.52148H86.2331L78.0918 19.339H81.2469L87.6846 9.07578L94.1224 19.339H97.2745L89.1331 6.52148Z"
        fill={color}
      />
      <path
        d="M156.859 6.52148H153.959L145.817 19.339H148.972L155.41 9.07578L161.848 19.339H165L156.859 6.52148Z"
        fill={color}
      />
      <rect
        x="82.4775"
        y="14.0586"
        width="10.3247"
        height="2.45311"
        fill={color}
      />
      <rect
        x="150.196"
        y="14.0586"
        width="10.3247"
        height="2.45311"
        fill={color}
      />
    </svg>
  );
}
